module.exports = __webpack_public_path__ + "static/media/business-insight-landing.2804bf58.png";